import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { AppNgZorroAntdModule } from './components/ng-zorro/ng-zorro-antd.module';
import { HasAnyAuthorityDirective } from "./directives/has-any-authority.directive";
import { SideNavDirective } from './directives/side-nav.directive';
import { AssinaturaModalComponent } from "./modal/assinatura-modal/assinatura-modal.component";
import { DateFormatPipe } from './pipes/date-format.pipe';
import { IconFilterPipe } from './pipes/iconFilter.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { CpfPipe } from "./pipes/cpf.pipe";
import { NgxMaskModule } from "ngx-mask";

@NgModule({
    declarations: [
        SearchPipe,
        DateFormatPipe,
        IconFilterPipe,
        SideNavDirective,
        HasAnyAuthorityDirective,
        AssinaturaModalComponent,
        CpfPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PerfectScrollbarModule,
        AppNgZorroAntdModule,
        SearchPipe,
        SideNavDirective,
        DateFormatPipe,
        IconFilterPipe,
        HasAnyAuthorityDirective,
        AssinaturaModalComponent,
        CpfPipe,
        NgxMaskModule,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PerfectScrollbarModule,
        AppNgZorroAntdModule,
        NgxMaskModule.forRoot(),
    ],
    providers: []
})

export class SharedModule { }
